import {
  ActiveTab,
  Dialog,
  Filters,
  Pagination,
  TabActionDialog
} from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export const PaymentEventsPath = "/payment-events";

export enum PaymentEventsListUrlFiltersEnum {
  query = "query",
  transactionId = "transactionId",
  orderCode = "orderCode",
  id = "id",
  api = "api",
  paymentMethodType = "paymentMethodType",
  reference = "reference"
}

export type PaymentEventsListUrlDialog = "add" | "view" | TabActionDialog;
export type PaymentEventsListUrlFilters = Filters<
  PaymentEventsListUrlFiltersEnum
>;

export type PaymentEventsListUrlQueryParams = ActiveTab &
  PaymentEventsListUrlFilters &
  Dialog<PaymentEventsListUrlDialog> &
  Pagination;

export const PaymentEventsListUrl = (
  params?: PaymentEventsListUrlQueryParams
) => PaymentEventsPath + "?" + stringifyQs(params);
